import { Box } from '@mui/system';
import React from 'react';
import CustomFormInput from '../../commonComponents/CustomFormInput';
import SubmitButton from '../../commonComponents/SubmitButton';
import { useTheme } from '@mui/material';

const AppointmentForm = ({ control, handleSubmit, onSubmit, t }) => {
  const theme = useTheme();
  const activeBg = theme.palette.secondary.main;
  const hoverBg = theme.palette.secondary.main + 'CC';
  return (
    <Box>
      <CustomFormInput name="from" type="datetime-local" control={control} label={t('From')} />
      <SubmitButton
        onClick={handleSubmit(onSubmit)}
        buttonText={t('Add')}
        backgroundColor={activeBg}
        hoverBgColor={hoverBg}
        color="inherit"
      />
    </Box>
  );
};

export default AppointmentForm;
